// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 24qDGfvb2rMn6oy8PVF95d
// Component: Y1S1dqRIPA8q

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import CollapsableWrapper from "../../CollapsableWrapper"; // plasmic-import: H39H8FW52Adf/component
import HubSelection from "../../HubSelection"; // plasmic-import: Xb5xo2JxQe/component
import Checklist from "../../Checklist"; // plasmic-import: xmtlGTX1K1/component

import { ThemeValue, useTheme } from "./PlasmicGlobalVariant__Theme"; // plasmic-import: 40N_XXvhaC/globalVariant
import { useScreenVariants as useScreenVariantsx6JbprEhruOi } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: X6JbprEhruOi/globalVariant

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic_plasmic_rich_components.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import plasmic_pro_pro_css from "../pro_pro/plasmic_pro_pro.module.css"; // plasmic-import: qtWvXH8Uhh67sc1TY2MZeK/projectcss
import projectcss from "./plasmic_hub_hub.module.css"; // plasmic-import: 24qDGfvb2rMn6oy8PVF95d/projectcss
import sty from "./PlasmicWelcomeView.module.css"; // plasmic-import: Y1S1dqRIPA8q/css

import Frame50Icon from "./icons/PlasmicIcon__Frame50"; // plasmic-import: HmJ04zxb3lMk/icon
import Line19Icon from "./icons/PlasmicIcon__Line19"; // plasmic-import: LNN8HvQhvpp9/icon

createPlasmicElementProxy;

export type PlasmicWelcomeView__VariantMembers = {
  isHideFirstHubButton: "isHideFirstHubButton";
  isOnlyHubList: "isOnlyHubList";
};
export type PlasmicWelcomeView__VariantsArgs = {
  isHideFirstHubButton?: SingleBooleanChoiceArg<"isHideFirstHubButton">;
  isOnlyHubList?: SingleBooleanChoiceArg<"isOnlyHubList">;
};
type VariantPropType = keyof PlasmicWelcomeView__VariantsArgs;
export const PlasmicWelcomeView__VariantProps = new Array<VariantPropType>(
  "isHideFirstHubButton",
  "isOnlyHubList"
);

export type PlasmicWelcomeView__ArgsType = {
  sectionStack1?: React.ReactNode;
};
type ArgPropType = keyof PlasmicWelcomeView__ArgsType;
export const PlasmicWelcomeView__ArgProps = new Array<ArgPropType>(
  "sectionStack1"
);

export type PlasmicWelcomeView__OverridesType = {
  root?: p.Flex<"div">;
  collapsableTextContainer?: p.Flex<typeof CollapsableWrapper>;
  textContainer?: p.Flex<"div">;
  introText?: p.Flex<"div">;
  feedbackText?: p.Flex<"div">;
  randomTipText?: p.Flex<"div">;
  leftSide?: p.Flex<"div">;
  collapsableHubLists?: p.Flex<typeof CollapsableWrapper>;
  yourHubs?: p.Flex<typeof HubSelection>;
  savedPublicHubs?: p.Flex<typeof HubSelection>;
  center?: p.Flex<"div">;
  collapsableButtonCollection?: p.Flex<typeof CollapsableWrapper>;
  yourFirstHub?: p.Flex<"div">;
  tooltipDefault?: p.Flex<"div">;
  frame40?: p.Flex<"div">;
  frame33?: p.Flex<"div">;
  chooseAnyOfTheseButtonsToCreateANewSectionWennIchWeiterSchreibDann?: p.Flex<"div">;
  yourFirstHubButton?: p.Flex<"div">;
  collapsableHubLists2?: p.Flex<typeof CollapsableWrapper>;
  sectionStack1Container?: p.Flex<"div">;
  rightSide?: p.Flex<"div">;
};

export interface DefaultWelcomeViewProps {
  sectionStack1?: React.ReactNode;
  isHideFirstHubButton?: SingleBooleanChoiceArg<"isHideFirstHubButton">;
  isOnlyHubList?: SingleBooleanChoiceArg<"isOnlyHubList">;
  className?: string;
}

const $$ = {};

function PlasmicWelcomeView__RenderFunc(props: {
  variants: PlasmicWelcomeView__VariantsArgs;
  args: PlasmicWelcomeView__ArgsType;
  overrides: PlasmicWelcomeView__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const stateSpecs: Parameters<typeof p.useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "isHideFirstHubButton",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) =>
          $props.isHideFirstHubButton
      },
      {
        path: "isOnlyHubList",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.isOnlyHubList
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  const globalVariants = ensureGlobalVariants({
    theme: useTheme(),
    screen: useScreenVariantsx6JbprEhruOi()
  });

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        plasmic_pro_pro_css.plasmic_tokens,
        sty.root,
        {
          [projectcss.global_theme_dark]: hasVariant(
            globalVariants,
            "theme",
            "dark"
          ),
          [sty.rootglobal_theme_dark]: hasVariant(
            globalVariants,
            "theme",
            "dark"
          ),
          [sty.rootisHideFirstHubButton]: hasVariant(
            $state,
            "isHideFirstHubButton",
            "isHideFirstHubButton"
          ),
          [sty.rootisOnlyHubList]: hasVariant(
            $state,
            "isOnlyHubList",
            "isOnlyHubList"
          )
        }
      )}
    >
      <CollapsableWrapper
        data-plasmic-name={"collapsableTextContainer"}
        data-plasmic-override={overrides.collapsableTextContainer}
        behaviour={"keepingWidth"}
        className={classNames("__wab_instance", sty.collapsableTextContainer, {
          [sty.collapsableTextContainerisOnlyHubList]: hasVariant(
            $state,
            "isOnlyHubList",
            "isOnlyHubList"
          )
        })}
      >
        <p.Stack
          as={"div"}
          data-plasmic-name={"textContainer"}
          data-plasmic-override={overrides.textContainer}
          hasGap={true}
          className={classNames(projectcss.all, sty.textContainer)}
        >
          <div
            data-plasmic-name={"introText"}
            data-plasmic-override={overrides.introText}
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.introText,
              {
                [sty.introTextglobal_theme_dark]: hasVariant(
                  globalVariants,
                  "theme",
                  "dark"
                )
              }
            )}
          >
            <React.Fragment>
              <React.Fragment>
                {
                  "We have some things for you here that you can explore \ud83c\udf81 \nLike automated ways to quickly create Hubs  based on certain plafroms. \nOr based on your interests. \nPerhaps they spark a\ud83d\udca1above your head and give you ideas on how "
                }
              </React.Fragment>
              {
                <span
                  className={classNames(
                    projectcss.all,
                    projectcss.span,
                    projectcss.__wab_text,
                    projectcss.plasmic_default__inline,
                    sty.span__lLiez
                  )}
                >
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#5978E8" }}
                    >
                      {"Hub"}
                    </span>
                    <React.Fragment>{"Hub"}</React.Fragment>
                  </React.Fragment>
                </span>
              }
              <React.Fragment>{" can make your life better.\n"}</React.Fragment>
              <span
                className={"plasmic_default__all plasmic_default__span"}
                style={{ fontStyle: "italic", color: "#979797" }}
              >
                {"If you haven\u2019t already, start the"}
              </span>
              <React.Fragment> </React.Fragment>
              {
                <span
                  className={classNames(
                    projectcss.all,
                    projectcss.span,
                    projectcss.__wab_text,
                    projectcss.plasmic_default__inline,
                    sty.span___0QWzN
                  )}
                >
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{
                        textDecorationLine: "underline",
                        fontWeight: 700,
                        color: "#5978E8"
                      }}
                    >
                      {"Guided Tour"}
                    </span>
                  </React.Fragment>
                </span>
              }
              <React.Fragment>{" \ud83d\ude80\n"}</React.Fragment>
              <span
                className={"plasmic_default__all plasmic_default__span"}
                style={{ color: "#979797", fontStyle: "italic" }}
              >
                {"You can also just watch a few of our"}
              </span>
              <React.Fragment> </React.Fragment>
              {
                <span
                  className={classNames(
                    projectcss.all,
                    projectcss.span,
                    projectcss.__wab_text,
                    projectcss.plasmic_default__inline,
                    sty.span__xFmpY
                  )}
                >
                  {"videos"}
                </span>
              }
              <React.Fragment>{" \ud83d\udcfc "}</React.Fragment>
              <span
                className={"plasmic_default__all plasmic_default__span"}
                style={{ fontStyle: "italic", color: "#979797" }}
              >
                {"to get started"}
              </span>
              <React.Fragment>{"."}</React.Fragment>
            </React.Fragment>
          </div>
          <div
            data-plasmic-name={"feedbackText"}
            data-plasmic-override={overrides.feedbackText}
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.feedbackText
            )}
          >
            <React.Fragment>
              <React.Fragment>{"PS.: "}</React.Fragment>
              <span
                className={"plasmic_default__all plasmic_default__span"}
                style={{ fontStyle: "italic", color: "#979797" }}
              >
                {"HubHub is currently in alpha 0.16"}
              </span>
              <React.Fragment>{"\nAs one of the "}</React.Fragment>
              {
                <span
                  className={classNames(
                    projectcss.all,
                    projectcss.span,
                    projectcss.__wab_text,
                    projectcss.plasmic_default__inline,
                    sty.span__dqHqb
                  )}
                >
                  {"chosen pioneers"}
                </span>
              }
              <React.Fragment>
                {
                  " \ud83e\udd83 who venture into this uncharted territory you can have a big impact on this project! \nThink about how YOU would make this tool the "
                }
              </React.Fragment>
              {
                <span
                  className={classNames(
                    projectcss.all,
                    projectcss.span,
                    projectcss.__wab_text,
                    projectcss.plasmic_default__inline,
                    sty.span___2MTd
                  )}
                >
                  {"best"}
                </span>
              }
              <React.Fragment>{" it can be. "}</React.Fragment>
              <span
                className={"plasmic_default__all plasmic_default__span"}
                style={{ fontStyle: "italic", color: "#979797" }}
              >
                {"And simply use the "}
              </span>
              <React.Fragment>{""}</React.Fragment>
              <span
                className={"plasmic_default__all plasmic_default__span"}
                style={{ fontStyle: "italic", color: "#979797" }}
              >
                {"\u2807"}
              </span>
              <React.Fragment>{""}</React.Fragment>
              <span
                className={"plasmic_default__all plasmic_default__span"}
                style={{ fontStyle: "italic", color: "#979797" }}
              >
                {
                  " menu in the top right corner to let us know what we might be missing."
                }
              </span>
            </React.Fragment>
          </div>
          <div
            data-plasmic-name={"randomTipText"}
            data-plasmic-override={overrides.randomTipText}
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.randomTipText
            )}
          >
            <React.Fragment>
              <React.Fragment>{"PPS.: "}</React.Fragment>
              <span
                className={"plasmic_default__all plasmic_default__span"}
                style={{ fontStyle: "italic", color: "#979797" }}
              >
                {"here is a random tipp:"}
              </span>
              <React.Fragment>
                {"\nDid you know that some of our users now open "}
              </React.Fragment>
              {
                <span
                  className={classNames(
                    projectcss.all,
                    projectcss.span,
                    projectcss.__wab_text,
                    projectcss.plasmic_default__inline,
                    sty.span__mLvGa
                  )}
                >
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#5978E8" }}
                    >
                      {"Hub"}
                    </span>
                    <React.Fragment>{"Hub"}</React.Fragment>
                  </React.Fragment>
                </span>
              }
              <React.Fragment>
                {
                  " instead of Spotify to listen to shows and music? Because they love having their own overviews (Hubs) of artists and playlists. And having a queue for each Hub."
                }
              </React.Fragment>
            </React.Fragment>
          </div>
        </p.Stack>
      </CollapsableWrapper>
      <p.Stack
        as={"div"}
        hasGap={true}
        className={classNames(projectcss.all, sty.freeBox__nLgz, {
          [sty.freeBoxglobal_theme_dark__nLgzOIz4X]: hasVariant(
            globalVariants,
            "theme",
            "dark"
          ),
          [sty.freeBoxisOnlyHubList__nLgzBJcK]: hasVariant(
            $state,
            "isOnlyHubList",
            "isOnlyHubList"
          )
        })}
      >
        {(hasVariant(globalVariants, "screen", "tablet") ? false : true) ? (
          <div
            data-plasmic-name={"leftSide"}
            data-plasmic-override={overrides.leftSide}
            className={classNames(projectcss.all, sty.leftSide, {
              [sty.leftSideglobal_theme_dark]: hasVariant(
                globalVariants,
                "theme",
                "dark"
              ),
              [sty.leftSideisHideFirstHubButton]: hasVariant(
                $state,
                "isHideFirstHubButton",
                "isHideFirstHubButton"
              ),
              [sty.leftSideisOnlyHubList]: hasVariant(
                $state,
                "isOnlyHubList",
                "isOnlyHubList"
              )
            })}
          >
            <CollapsableWrapper
              data-plasmic-name={"collapsableHubLists"}
              data-plasmic-override={overrides.collapsableHubLists}
              behaviour={"keepingWidth"}
              className={classNames("__wab_instance", sty.collapsableHubLists, {
                [sty.collapsableHubListsisHideFirstHubButton]: hasVariant(
                  $state,
                  "isHideFirstHubButton",
                  "isHideFirstHubButton"
                )
              })}
            >
              <HubSelection
                data-plasmic-name={"yourHubs"}
                data-plasmic-override={overrides.yourHubs}
                className={classNames("__wab_instance", sty.yourHubs, {
                  [sty.yourHubsglobal_theme_dark]: hasVariant(
                    globalVariants,
                    "theme",
                    "dark"
                  ),
                  [sty.yourHubsisHideFirstHubButton]: hasVariant(
                    $state,
                    "isHideFirstHubButton",
                    "isHideFirstHubButton"
                  ),
                  [sty.yourHubsisOnlyHubList]: hasVariant(
                    $state,
                    "isOnlyHubList",
                    "isOnlyHubList"
                  )
                })}
                context={"welcomeView"}
              />

              <HubSelection
                data-plasmic-name={"savedPublicHubs"}
                data-plasmic-override={overrides.savedPublicHubs}
                className={classNames("__wab_instance", sty.savedPublicHubs, {
                  [sty.savedPublicHubsglobal_theme_dark]: hasVariant(
                    globalVariants,
                    "theme",
                    "dark"
                  ),
                  [sty.savedPublicHubsisHideFirstHubButton]: hasVariant(
                    $state,
                    "isHideFirstHubButton",
                    "isHideFirstHubButton"
                  ),
                  [sty.savedPublicHubsisOnlyHubList]: hasVariant(
                    $state,
                    "isOnlyHubList",
                    "isOnlyHubList"
                  )
                })}
                context={"welcomeView"}
                headline={
                  hasVariant(
                    $state,
                    "isHideFirstHubButton",
                    "isHideFirstHubButton"
                  )
                    ? "Saved Public Hubs"
                    : hasVariant(globalVariants, "theme", "dark")
                    ? "Saved Public Hubs"
                    : hasVariant(globalVariants, "screen", "smallDesktop")
                    ? "Saved Public Hubs"
                    : "Saved Public Hubs"
                }
              />
            </CollapsableWrapper>
          </div>
        ) : null}
        <div
          data-plasmic-name={"center"}
          data-plasmic-override={overrides.center}
          className={classNames(projectcss.all, sty.center, {
            [sty.centerglobal_theme_dark]: hasVariant(
              globalVariants,
              "theme",
              "dark"
            ),
            [sty.centerisHideFirstHubButton]: hasVariant(
              $state,
              "isHideFirstHubButton",
              "isHideFirstHubButton"
            ),
            [sty.centerisOnlyHubList]: hasVariant(
              $state,
              "isOnlyHubList",
              "isOnlyHubList"
            )
          })}
        >
          <CollapsableWrapper
            data-plasmic-name={"collapsableButtonCollection"}
            data-plasmic-override={overrides.collapsableButtonCollection}
            behaviour={"keepingWidth"}
            className={classNames(
              "__wab_instance",
              sty.collapsableButtonCollection,
              {
                [sty.collapsableButtonCollectionisHideFirstHubButton]:
                  hasVariant(
                    $state,
                    "isHideFirstHubButton",
                    "isHideFirstHubButton"
                  )
              }
            )}
          >
            <p.Stack
              as={"div"}
              data-plasmic-name={"yourFirstHub"}
              data-plasmic-override={overrides.yourFirstHub}
              hasGap={true}
              className={classNames(projectcss.all, sty.yourFirstHub, {
                [sty.yourFirstHubisHideFirstHubButton]: hasVariant(
                  $state,
                  "isHideFirstHubButton",
                  "isHideFirstHubButton"
                )
              })}
            >
              <p.Stack
                as={"div"}
                data-plasmic-name={"tooltipDefault"}
                data-plasmic-override={overrides.tooltipDefault}
                hasGap={true}
                className={classNames(projectcss.all, sty.tooltipDefault)}
              >
                <div
                  data-plasmic-name={"frame40"}
                  data-plasmic-override={overrides.frame40}
                  className={classNames(projectcss.all, sty.frame40)}
                >
                  <p.Stack
                    as={"div"}
                    data-plasmic-name={"frame33"}
                    data-plasmic-override={overrides.frame33}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.frame33)}
                  >
                    <div
                      data-plasmic-name={
                        "chooseAnyOfTheseButtonsToCreateANewSectionWennIchWeiterSchreibDann"
                      }
                      data-plasmic-override={
                        overrides.chooseAnyOfTheseButtonsToCreateANewSectionWennIchWeiterSchreibDann
                      }
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.chooseAnyOfTheseButtonsToCreateANewSectionWennIchWeiterSchreibDann
                      )}
                    >
                      {
                        "Tipp: Start here \n to start our guided tour \ud83d\ude0a"
                      }
                    </div>
                  </p.Stack>
                  <div
                    className={classNames(projectcss.all, sty.freeBox__sVtzk)}
                  >
                    <p.Stack
                      as={Frame50Icon}
                      hasGap={true}
                      className={classNames(projectcss.all, sty.svg__jAmvX)}
                      role={"img"}
                    />
                  </div>
                </div>
              </p.Stack>
              <div
                data-plasmic-name={"yourFirstHubButton"}
                data-plasmic-override={overrides.yourFirstHubButton}
                className={classNames(projectcss.all, sty.yourFirstHubButton, {
                  [sty.yourFirstHubButtonisHideFirstHubButton]: hasVariant(
                    $state,
                    "isHideFirstHubButton",
                    "isHideFirstHubButton"
                  )
                })}
              >
                <div className={classNames(projectcss.all, sty.freeBox__g8KNo)}>
                  <p.Stack
                    as={"div"}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.freeBox__kHoJu)}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text___95Q6S
                      )}
                    >
                      {"Create your first Hub"}
                    </div>
                    <Line19Icon
                      className={classNames(projectcss.all, sty.svg__trNns)}
                      role={"img"}
                    />
                  </p.Stack>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__wbRto
                    )}
                  >
                    <React.Fragment>
                      <React.Fragment>
                        {"You\u2019ll get some \n"}
                      </React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#5978E8" }}
                      >
                        {"interests"}
                      </span>
                      <React.Fragment>
                        {" to select and \nwe\u2019ll create your\n\u201c"}
                      </React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ fontWeight: 700 }}
                      >
                        {"Interest-based Hub"}
                      </span>
                      <React.Fragment>{"\u201d"}</React.Fragment>
                    </React.Fragment>
                  </div>
                </div>
                <p.PlasmicImg
                  alt={""}
                  className={classNames(sty.img__na5Y)}
                  displayHeight={"auto"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"none"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"172px"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={{
                    src: "https://img.plasmic.app/img-optimizer/v1/img/9375a3c5c67da53c8f8a8e2c4391caa1.png",
                    fullWidth: 1087,
                    fullHeight: 890
                  }}
                />
              </div>
            </p.Stack>
            <div className={classNames(projectcss.all, sty.freeBox__x4F64)}>
              <p.Stack
                as={"div"}
                hasGap={true}
                className={classNames(projectcss.all, sty.freeBox__pYjg)}
              >
                {(
                  hasVariant(globalVariants, "screen", "tablet") ? true : false
                ) ? (
                  <CollapsableWrapper
                    data-plasmic-name={"collapsableHubLists2"}
                    data-plasmic-override={overrides.collapsableHubLists2}
                    behaviour={"keepingWidth"}
                    className={classNames(
                      "__wab_instance",
                      sty.collapsableHubLists2
                    )}
                  >
                    <HubSelection
                      className={classNames(
                        "__wab_instance",
                        sty.hubSelection___41Sj,
                        {
                          [sty.hubSelectionglobal_theme_dark___41SjOIz4X]:
                            hasVariant(globalVariants, "theme", "dark"),
                          [sty.hubSelectionisHideFirstHubButton___41SjAjlm5]:
                            hasVariant(
                              $state,
                              "isHideFirstHubButton",
                              "isHideFirstHubButton"
                            )
                        }
                      )}
                      context={"welcomeView"}
                    />

                    <HubSelection
                      className={classNames(
                        "__wab_instance",
                        sty.hubSelection__mml4T,
                        {
                          [sty.hubSelectionglobal_theme_dark__mml4TOIz4X]:
                            hasVariant(globalVariants, "theme", "dark"),
                          [sty.hubSelectionisHideFirstHubButton__mml4TAjlm5]:
                            hasVariant(
                              $state,
                              "isHideFirstHubButton",
                              "isHideFirstHubButton"
                            ),
                          [sty.hubSelectionisOnlyHubList__mml4TBJcK]:
                            hasVariant($state, "isOnlyHubList", "isOnlyHubList")
                        }
                      )}
                      context={"welcomeView"}
                      headline={
                        hasVariant(
                          $state,
                          "isHideFirstHubButton",
                          "isHideFirstHubButton"
                        )
                          ? "Saved Public Hubs"
                          : hasVariant(globalVariants, "theme", "dark")
                          ? "Saved Public Hubs"
                          : hasVariant(globalVariants, "screen", "smallDesktop")
                          ? "Saved Public Hubs"
                          : "Saved Public Hubs"
                      }
                    />
                  </CollapsableWrapper>
                ) : null}
                <Checklist
                  className={classNames("__wab_instance", sty.checklist__grl80)}
                />
              </p.Stack>
              <p.PlasmicImg
                alt={""}
                className={classNames(sty.img__pK21D)}
                displayHeight={"auto"}
                displayMaxHeight={"none"}
                displayMaxWidth={"50%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"auto"}
                loader={"plasmic"}
                loading={"lazy"}
                src={{
                  src: "https://img.plasmic.app/img-optimizer/v1/img/4b56161d44bd2b2668c67600fd5ccfa3.png",
                  fullWidth: 1357,
                  fullHeight: 2815
                }}
              />

              {(
                hasVariant(globalVariants, "screen", "tablet") ? false : true
              ) ? (
                <p.PlasmicImg
                  alt={""}
                  className={classNames(sty.img__vqsvv, {
                    [sty.imgglobal_theme_dark__vqsvvOIz4X]: hasVariant(
                      globalVariants,
                      "theme",
                      "dark"
                    )
                  })}
                  displayHeight={"auto"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"90%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"auto"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={{
                    src: "https://img.plasmic.app/img-optimizer/v1/img/a445ee4597f0b83dfe57cd997a307f26.png",
                    fullWidth: 1497,
                    fullHeight: 1155
                  }}
                />
              ) : null}
            </div>
          </CollapsableWrapper>
          <div
            data-plasmic-name={"sectionStack1Container"}
            data-plasmic-override={overrides.sectionStack1Container}
            className={classNames(projectcss.all, sty.sectionStack1Container, {
              [sty.sectionStack1Containerglobal_theme_dark]: hasVariant(
                globalVariants,
                "theme",
                "dark"
              ),
              [sty.sectionStack1ContainerisHideFirstHubButton]: hasVariant(
                $state,
                "isHideFirstHubButton",
                "isHideFirstHubButton"
              )
            })}
          >
            {p.renderPlasmicSlot({
              defaultContents: null,
              value: args.sectionStack1
            })}
          </div>
        </div>
        {(
          hasVariant($state, "isOnlyHubList", "isOnlyHubList")
            ? true
            : hasVariant(globalVariants, "screen", "tablet")
            ? false
            : true
        ) ? (
          <div
            data-plasmic-name={"rightSide"}
            data-plasmic-override={overrides.rightSide}
            className={classNames(projectcss.all, sty.rightSide, {
              [sty.rightSideisOnlyHubList]: hasVariant(
                $state,
                "isOnlyHubList",
                "isOnlyHubList"
              )
            })}
          >
            <Checklist
              className={classNames("__wab_instance", sty.checklist__tFux2)}
            />
          </div>
        ) : null}
      </p.Stack>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "collapsableTextContainer",
    "textContainer",
    "introText",
    "feedbackText",
    "randomTipText",
    "leftSide",
    "collapsableHubLists",
    "yourHubs",
    "savedPublicHubs",
    "center",
    "collapsableButtonCollection",
    "yourFirstHub",
    "tooltipDefault",
    "frame40",
    "frame33",
    "chooseAnyOfTheseButtonsToCreateANewSectionWennIchWeiterSchreibDann",
    "yourFirstHubButton",
    "collapsableHubLists2",
    "sectionStack1Container",
    "rightSide"
  ],
  collapsableTextContainer: [
    "collapsableTextContainer",
    "textContainer",
    "introText",
    "feedbackText",
    "randomTipText"
  ],
  textContainer: [
    "textContainer",
    "introText",
    "feedbackText",
    "randomTipText"
  ],
  introText: ["introText"],
  feedbackText: ["feedbackText"],
  randomTipText: ["randomTipText"],
  leftSide: ["leftSide", "collapsableHubLists", "yourHubs", "savedPublicHubs"],
  collapsableHubLists: ["collapsableHubLists", "yourHubs", "savedPublicHubs"],
  yourHubs: ["yourHubs"],
  savedPublicHubs: ["savedPublicHubs"],
  center: [
    "center",
    "collapsableButtonCollection",
    "yourFirstHub",
    "tooltipDefault",
    "frame40",
    "frame33",
    "chooseAnyOfTheseButtonsToCreateANewSectionWennIchWeiterSchreibDann",
    "yourFirstHubButton",
    "collapsableHubLists2",
    "sectionStack1Container"
  ],
  collapsableButtonCollection: [
    "collapsableButtonCollection",
    "yourFirstHub",
    "tooltipDefault",
    "frame40",
    "frame33",
    "chooseAnyOfTheseButtonsToCreateANewSectionWennIchWeiterSchreibDann",
    "yourFirstHubButton",
    "collapsableHubLists2"
  ],
  yourFirstHub: [
    "yourFirstHub",
    "tooltipDefault",
    "frame40",
    "frame33",
    "chooseAnyOfTheseButtonsToCreateANewSectionWennIchWeiterSchreibDann",
    "yourFirstHubButton"
  ],
  tooltipDefault: [
    "tooltipDefault",
    "frame40",
    "frame33",
    "chooseAnyOfTheseButtonsToCreateANewSectionWennIchWeiterSchreibDann"
  ],
  frame40: [
    "frame40",
    "frame33",
    "chooseAnyOfTheseButtonsToCreateANewSectionWennIchWeiterSchreibDann"
  ],
  frame33: [
    "frame33",
    "chooseAnyOfTheseButtonsToCreateANewSectionWennIchWeiterSchreibDann"
  ],
  chooseAnyOfTheseButtonsToCreateANewSectionWennIchWeiterSchreibDann: [
    "chooseAnyOfTheseButtonsToCreateANewSectionWennIchWeiterSchreibDann"
  ],
  yourFirstHubButton: ["yourFirstHubButton"],
  collapsableHubLists2: ["collapsableHubLists2"],
  sectionStack1Container: ["sectionStack1Container"],
  rightSide: ["rightSide"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  collapsableTextContainer: typeof CollapsableWrapper;
  textContainer: "div";
  introText: "div";
  feedbackText: "div";
  randomTipText: "div";
  leftSide: "div";
  collapsableHubLists: typeof CollapsableWrapper;
  yourHubs: typeof HubSelection;
  savedPublicHubs: typeof HubSelection;
  center: "div";
  collapsableButtonCollection: typeof CollapsableWrapper;
  yourFirstHub: "div";
  tooltipDefault: "div";
  frame40: "div";
  frame33: "div";
  chooseAnyOfTheseButtonsToCreateANewSectionWennIchWeiterSchreibDann: "div";
  yourFirstHubButton: "div";
  collapsableHubLists2: typeof CollapsableWrapper;
  sectionStack1Container: "div";
  rightSide: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicWelcomeView__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicWelcomeView__VariantsArgs;
    args?: PlasmicWelcomeView__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicWelcomeView__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicWelcomeView__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicWelcomeView__ArgProps,
          internalVariantPropNames: PlasmicWelcomeView__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicWelcomeView__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicWelcomeView";
  } else {
    func.displayName = `PlasmicWelcomeView.${nodeName}`;
  }
  return func;
}

export const PlasmicWelcomeView = Object.assign(
  // Top-level PlasmicWelcomeView renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    collapsableTextContainer: makeNodeComponent("collapsableTextContainer"),
    textContainer: makeNodeComponent("textContainer"),
    introText: makeNodeComponent("introText"),
    feedbackText: makeNodeComponent("feedbackText"),
    randomTipText: makeNodeComponent("randomTipText"),
    leftSide: makeNodeComponent("leftSide"),
    collapsableHubLists: makeNodeComponent("collapsableHubLists"),
    yourHubs: makeNodeComponent("yourHubs"),
    savedPublicHubs: makeNodeComponent("savedPublicHubs"),
    center: makeNodeComponent("center"),
    collapsableButtonCollection: makeNodeComponent(
      "collapsableButtonCollection"
    ),
    yourFirstHub: makeNodeComponent("yourFirstHub"),
    tooltipDefault: makeNodeComponent("tooltipDefault"),
    frame40: makeNodeComponent("frame40"),
    frame33: makeNodeComponent("frame33"),
    chooseAnyOfTheseButtonsToCreateANewSectionWennIchWeiterSchreibDann:
      makeNodeComponent(
        "chooseAnyOfTheseButtonsToCreateANewSectionWennIchWeiterSchreibDann"
      ),
    yourFirstHubButton: makeNodeComponent("yourFirstHubButton"),
    collapsableHubLists2: makeNodeComponent("collapsableHubLists2"),
    sectionStack1Container: makeNodeComponent("sectionStack1Container"),
    rightSide: makeNodeComponent("rightSide"),

    // Metadata about props expected for PlasmicWelcomeView
    internalVariantProps: PlasmicWelcomeView__VariantProps,
    internalArgProps: PlasmicWelcomeView__ArgProps
  }
);

export default PlasmicWelcomeView;
/* prettier-ignore-end */
